import { SvgIcon } from '@mui/material';

export const StoreIcon = props => {
  return (
    <SvgIcon {...props}>
      <g id="Group_64" data-name="Group 64" transform="translate(0 2)">
        <path
          id="Path_36"
          data-name="Path 36"
          d="M22.785,66.792h-.4V56.413a3.247,3.247,0,0,0,1.5-2.732.35.35,0,0,0-.046-.174l-2.776-4.858a1.1,1.1,0,0,0-.953-.553H3.775a1.1,1.1,0,0,0-.953.553L.046,53.507A.35.35,0,0,0,0,53.681a3.247,3.247,0,0,0,1.5,2.732V66.792H1.1a.35.35,0,0,0,0,.7H22.785a.35.35,0,0,0,0-.7ZM.724,54.031H1.845a.35.35,0,1,0,0-.7H.953L3.43,49a.4.4,0,0,1,.346-.2H20.108a.4.4,0,0,1,.346.2l2.477,4.335h-.893a.35.35,0,1,0,0,.7h1.122a2.548,2.548,0,0,1-5.047,0h2.43a.35.35,0,1,0,0-.7H3.341a.35.35,0,1,0,0,.7h2.43a2.548,2.548,0,0,1-5.047,0Zm16.639,0a2.547,2.547,0,0,1-5.047,0Zm-5.8,0a2.547,2.547,0,0,1-5.047,0Zm8.251,12.762H16.03v-1.17h3.787Zm0-1.87H16.03v-6.4h3.787Zm1.87,1.87h-1.17V58.168a.35.35,0,0,0-.35-.35H15.681a.35.35,0,0,0-.35.35v8.624H2.2V56.753a3.244,3.244,0,0,0,3.95-1.606,3.247,3.247,0,0,0,5.8,0,3.247,3.247,0,0,0,5.8,0,3.245,3.245,0,0,0,3.95,1.606Z"
          transform="translate(0 -48.096)"
        />
      </g>
    </SvgIcon>
  );
};
